// @ts-nocheck

import * as Types from '../../../../graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type MarkNotificationsAsReadMutationVariables = Types.Exact<{ [key: string]: never }>;

export type MarkNotificationsAsReadMutation = {
  readAllNotifications: { notifications?: Array<{ uid: string } | null> | null };
};

export const MarkNotificationsAsReadDocument = gql`
    mutation MarkNotificationsAsRead {
  readAllNotifications {
    notifications {
      uid
    }
  }
}
    ` as unknown as DocumentNode<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>;
